import React from 'react'

import css from './style.module.css'
export default ({ heading, size, className, children, bold, italic, style, block, color, ...props }) => {
    let classes = [css.display]

    if(size) classes.push(css[`display${size}`])
    if(bold) classes.push(css.bold)
    if(italic) classes.push(css.italic)
    if(className) classes.push(className)
    if(block) classes.push(css.block)

    if(heading) {
        if(size === 1) return <h1 className={classes.join(' ')} {...props}>{children}</h1>
        if(size === 2) return <h2 className={classes.join(' ')} {...props}>{children}</h2>
        if(size === 3) return <h3 className={classes.join(' ')} {...props}>{children}</h3>
    }

    return <span
                className={classes.join(' ')}
                {...props}
                style={{...style, color: color}}
            >{children}</span>
}


// WEBPACK FOOTER //
// ./src/SPRINTA/v2/atoms/Display/index.js